import { render, staticRenderFns } from "./ResourcePlatform.vue?vue&type=template&id=d59b4f14&scoped=true"
import script from "./ResourcePlatform.vue?vue&type=script&lang=js"
export * from "./ResourcePlatform.vue?vue&type=script&lang=js"
import style0 from "./ResourcePlatform.vue?vue&type=style&index=0&id=d59b4f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59b4f14",
  null
  
)

export default component.exports